import { useSharedLinkInitialData } from '@hook/sharedLinkData';
import { useSharedLinkId, useSharedLinkResource } from '@hook/useSharedLinkResource';
import SharedLinkState from '@module/sharedLinkState';
import { getOrderByOrderId } from '@storeData/order';
import { redirectToHome } from '@util/routerService';
import { useSelector } from 'react-redux';
import PaymentInvoiceModal from './paymentInvoiceModal';

function PaymentPage() {
    const orderId = useSharedLinkId();
    const { configData } = useSelector((state: any) => state.store.storeData);
    const store = useSelector((state: any) => state);
    const currentStoreId = store?.store?.storeData?.storeId || configData?.storeId;
    const { data: orderData, state, retry } = useSharedLinkResource({
        id: orderId,
        initialData: useSharedLinkInitialData('order', orderId),
        fetcher: (id) => getOrderByOrderId(id, currentStoreId, configData?.tenantId)
    });

    return (
        <div>
            {state === 'ready' && <PaymentInvoiceModal
                order={orderData}
                handleClose={() => { }} />}
            <SharedLinkState
                state={state}
                onRetry={retry}
                onSecondaryAction={Boolean(configData?.storeConfig?.basicConfig?.catalogue) ? redirectToHome : undefined}
                loadingText="Loading your payment details..."
                notFoundText="The payment link is not available."
                errorText="We couldn't load your payment details. Please check your connection and try again."
                secondaryActionText="Explore more services"
            />
        </div>
    )
}

export default PaymentPage
